<template>
    <div class="center_quote_cart_box">
        <!-- 标题 -->
        <center-title>{{$t("message.cqcart.title")}}</center-title>
        <quote-cart-table></quote-cart-table>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        quoteCartTable: () => import("@/components/center/quoteCartTable"),
    },
	computed: mapState({
	    power: state => state.user.power,
	}),
	beforeRouteEnter (to, from, next) {
	    next(vm => {
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(18)|| vm.power.includes(111);
				if(!allow){
				    vm.$router.back();
				    return false;
				}else{
				   
				}
			}, 500)
	    })
	},
}
</script>

<style scoped>
/* 报价车内容区域 */
.center_quote_cart_content{
    background: #fff;
}
</style>
